// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"16":"a5e4a851","229":"a7911e3b","291":"1c336050","694":"9b5351d6","796":"03f2c7e2","959":"116cd097"}[chunkId] + ".chunk.css";
};